import React from "react";
import { Box, Toolbar, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import LogoImg from "../../assets/images/intellica.webp";
import { scopes } from "../../../authConfig";
import {
  Logo,
  MobileMenuButton,
  MobileMenuContainer,
  Nav,
  NavbarContainer,
} from "./Styles";

import { DesktopNavigation } from "./DesktopNavigation";
import { MobileNavigation } from "./MobileNavigation";

import { AiOutlineMenu } from "react-icons/ai";

interface Props {
  window?: () => Window;
}

const Navbar = (props: Props) => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [visible, setVisible] = React.useState(false);

  const isMob = useMediaQuery("(max-width: 480px)");

  const signIn = async () => {
    const loginRequest = {
      scopes,
    };

    instance
      .loginRedirect(loginRequest)
      .then((res: any) => {
        console.log("this is res ", res);
      })
      .catch((err: any) => {
        console.log("Error during login:", err);
      });
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const ModalVisibility = (state: boolean) => {
    setVisible(state);
  };

  return (
    <Box sx={{ display: "flex" }}>

      <NavbarContainer>
        <Nav>

          <Logo
            src={LogoImg}
            alt="logo"
          />

          <DesktopNavigation onLogin={signIn} />

          <MobileMenuContainer>
            <MobileMenuButton
              onClick={handleDrawerToggle}
              aria-label="open menu"
              data-test="menuOpenButton"
            >
              <AiOutlineMenu size={isMob ? 35 : 50} />
            </MobileMenuButton>

            <MobileNavigation
              open={mobileOpen}
              onClose={() => setMobileOpen(false)}
            />
          </MobileMenuContainer>

        </Nav>
      </NavbarContainer>

      <Box
        component="main"
        sx={{
          width: "100%",
        }}
      >
        <Toolbar />
      </Box>

    </Box>
  );
};

export default Navbar;
